export enum FirestoreCollection {
  BaseModels = 'base_models',
  FormSubmissions = 'form_submissions'
}
